import React from 'react';
import Search from './Search';
import '../../assets/css/banner.css';
import { CMS_LOCATION, INITIAL_SUGGESTIONS_URL } from '../../constants/constants';

class HomePageBanner extends React.Component {
    constructor(props) {
        super(props);
        this.autoCompleteRef = React.createRef();
        this.inputRef = React.createRef();
        this.BannerStyle = {
            "backgroundImage": "url(" + CMS_LOCATION + this.props.Image + ")"
        };
    }

    render() {
        if (
            window.oneAppFlag !== true
          ) {
            return (
                <section className="main large-mw-none banner-section padding-all-zero" role="region">
                    <div className="row  padding-all-zero new-support-banner">
                        <div className="column tiny-12  padding-all-zero article-hero-bg" alt="" >
                            <h1 className="article-hero_title" id="how_can_i_help">Welcome to Verizon Home Support</h1>
                            <div className="article-hero_search">
                                <Search searchIconHeight="23" PlaceHolder="Search support" AriaLabel="how_can_i_help"></Search>
                            </div>
                        </div>
                    </div>
                </section>
            )
        }
        else{
            return null;
        }
        
    }
}

export default HomePageBanner


// WEBPACK FOOTER //
// ./src/components/modules/HomePageBanner.js